export const defineIsActive = (location: 'header' | 'form', isHeaderSticked: boolean) => {
  return (location === 'form' && !isHeaderSticked) || (location === 'header' && isHeaderSticked);
};
